var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2733 3.83214C16.0648 2.65904 14.4257 2 12.7166 2H12.0779C10.3688 2 8.72973 2.65904 7.52123 3.83214C6.31273 5.00524 5.33004 6.86202 5.63381 9.64032C5.87 11.8006 9.82811 18.1604 11.5773 20.8827C11.9638 21.4843 12.8307 21.4843 13.2172 20.8827C14.9664 18.1604 18.9245 11.8006 19.1607 9.64032C19.4645 6.86202 18.4818 5.00524 17.2733 3.83214Z",
    stroke: "#F20E45",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4901,
    cy: 8.00422,
    r: 2.25959,
    stroke: "#F20E45",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.35fc05237122d4e54b9741cacf69dc8f.svg";
export { ForwardRef as ReactComponent };